
export const UPDATE_USER_CONTEXT = 'UPDATE_USER_CONTEXT';

export function dispatchUpdateUserContext(userContext, sessionToken) {
    return {
        type: UPDATE_USER_CONTEXT,
        userContext,
        sessionToken
    }
};

export default function updateUserContext(userContext, sessionToken) {
    return function(dispatch, getState) {
        dispatch(dispatchUpdateUserContext(userContext, sessionToken));
        return Promise.resolve();
    }
}